import apiClient from "services/axios";
import store from "store";

const API = {
  login: "/api/v1/accounts/login",
  logout: "/api/v1/accounts/logout",
};

export const login = async (username, password) => {
  const response = await apiClient.post(API.login, { username, password });
  if (response) {
    const { token, user, mqtt } = response.data;
    store.set("token", token);
    store.set("user", user);
    store.set("mqttAccess", mqtt);
    return response.data;
  }
  return false;
};

export const logout = async () => {
  const response = await apiClient.get(API.logout);
  if (response) {
    return response.data;
  }
  return false;
};
